module.exports = __webpack_public_path__ + "img/anewitem-wrist-watches.da7129ec.svg";